import { motion } from "framer-motion";

export function MaskedLine({ children, delay = 0, className = "" }) {
  return (
    <motion.span
      className="line-mask"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
    >
      <motion.span
        className={`block ${className}`}
        variants={{ hidden: { y: "110%" }, visible: { y: "0%" } }}
        transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
      >
        {children}
      </motion.span>
    </motion.span>
  );
}

export function FadeUp({ children, delay = 0, className = "", y = 28 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function Eyebrow({ children, dark = false }) {
  return (
    <p
      className={`text-[11px] md:text-xs font-medium uppercase tracking-editorial mb-5 ${
        dark ? "text-gold" : "text-[#8B7355]"
      }`}
    >
      {children}
    </p>
  );
}
